import styled from "styled-components"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from 'react-responsive'; 
import { FaHeart } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { AiFillPhone } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";



import pages from "../utils/pages";

const Footer = () => {
  
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const fix = useMediaQuery({ query: '(min-width: 750px) and (max-width: 855px)' });
  
  return <Wrapper>
        <div className={isMobile ? '' : 'container'}>
            <div className="row">
                <div className="col-12 col-md-4">
                    <div className="card">
                        <h3>
                            {t('infoLegali')}
                        </h3>
                        <ul>
                            <li>Il Leone di Mare</li>
                            <li>
                                <Link style={fix ? {fontSize: '12px'} : {}}  className="link" to='https://www.google.com/maps/place//data=!4m2!3m1!1s0x133b1357eb0c928f:0xd47bf5d57d6171af?sa=X&ved=1t:8290&ictx=111'>
                                    Via Giovanni da Procida, 61
                                </Link>
                            </li>
                            <li>
                                {t('iva')} 07734301216
                            </li>                            
                            <li>
                                <Link className="link" to='/policy'>
                                    {t('privacyPolicy')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-4 p-15-0">
                    <div className="card">
                        <h3>
                            {t('pagine')}
                        </h3>
                        <ul>
                            {
                                pages.map((page) => {
                                    return <li key={page.id}>
                                        <Link to={page.path} className="link">
                                            {t(page.text)}
                                        </Link>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <div className="card">
                        <h3>
                            {t('contatti')}
                        </h3>
                        <ul>
                            <li>
                                <Link  to='https://www.instagram.com/illeonedimarehotel/' className="link"><FaInstagram className="icon" /><div>illeonedimarehotel</div></Link>
                            </li>
                            <li>
                                <Link style={fix ? {fontSize: '12px'} : {}} to='mailto:illeonedimare@gmail.com' className="link"><BiLogoGmail className="icon" />illeonedimare@gmail.com</Link>
                            </li>
                            <li>
                                <Link to='tel:+39081 896 87 60' className="link"><AiFillPhone className="icon" />+39 081 896 87 60</Link>
                            </li>
                            <li>
                                <Link to='https://wa.me/393319005826' className="link"><FaWhatsapp className="icon" />+39 331 900 58 26</Link>
                            </li>       
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="leo container">
            Made with <FaHeart className="icon" /> by <a className="link" href="https://wa.me/393339825432">LeoBDev</a> 
        </div>
  </Wrapper>
}

export default Footer;

const Wrapper = styled.footer`
    background-color: var(--footer-dark);
    padding: 40px 0px 75px 0px;
    .leo {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        color: white;
        .icon {
            font-size: 32px;
            color: red;
            padding: 0px 5px;
        }
        .link {
            padding-left: 6px;
            font-weight: bold;
            color: var(--logo);
        }
    }
            .row {
                margin: 0 auto;
                justify-content: space-between;
                .col-12 {
                    padding: 15px;
                    .card {
                            height: 350px;
                            border-radius: 10px;
                            background-color: var(--footer);
                            padding: 15px;
                            ul {
                                margin-top: 20px;
                                    li {
                                        list-style: none;
                                        font-size: 16px;
                                        color: lightgray;
                                        display: flex;
                                        justify-content: flex-start;
                                        align-items: center;
                                        .link {
                                            display: flex;
                                            justify-content: flex-start;
                                            padding: 5px 0px;
                                            align-items: center;
                                            color: lightgray;
                                        }
                                        &:not(:last-child) {
                                            margin-bottom: 10px;
                                        }
                                        .icon {
                                            font-size: 24px;
                                            margin-right: 8px;
                                        }
                                    }
                            }
                            h3 {
                                font-size: 22px;
                                width: 100%;
                                padding-bottom: 10px;
                                padding-left: 2px;
                                color: white;
                                border-bottom: 2px solid var(--logo);
                            }
                        }
                    }
            }
`
